// The presenter's keys, heard on the whole document, so a page turns
// wherever the focus was left.

export default {
  handleKeydown(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    // Typing a note is typing, not turning pages.
    if (event.target.closest?.("input, textarea, [contenteditable]")) return;
    // Choosing boards: the keys are the list's, and Esc puts it away.
    if (this.hasChooserTarget && !this.chooserTarget.hidden) {
      if (event.key === "Escape") {
        if (this.dragging) this.cancelDrag();
        else this.closeChooser();
      }
      return;
    }

    switch (event.key) {
      case "ArrowRight":
      case "PageDown":
      case " ":
        event.preventDefault();
        this.next();
        break;
      case "ArrowLeft":
      case "PageUp":
        event.preventDefault();
        this.previous();
        break;
      case "Home":
        event.preventDefault();
        this.showSlide(this.visibleIndices()[0] ?? 0);
        break;
      case "End":
        event.preventDefault();
        this.showSlide(this.visibleIndices().pop() ?? this.totalSlides - 1);
        break;
      case "o":
      case "O":
        event.preventDefault();
        this.toggleOverview();
        break;
      // The overview's boards, larger or smaller, or fitted to the screen.
      case "-":
        if (!this.overview) break;
        event.preventDefault();
        this.overviewSmaller();
        break;
      case "+":
      case "=":
        if (!this.overview) break;
        event.preventDefault();
        this.overviewLarger();
        break;
      case "0":
        if (!this.overview) break;
        event.preventDefault();
        this.overviewFit();
        break;
      case "f":
      case "F":
        event.preventDefault();
        this.toggleFullscreen();
        break;
      case "n":
      case "N":
        event.preventDefault();
        this.toggleNotes();
        break;
      case "b":
      case "B":
        event.preventDefault();
        this.turnOver();
        break;
      case "Escape": {
        event.preventDefault();
        // Close what is open before leaving: a menu, the overview, then
        // fullscreen (which the browser closes itself), then the deck.
        const openMenu = this.element.querySelector(
          '[data-dropdown-target="menu"]:not(.hidden)',
        );
        if (openMenu) {
          openMenu.classList.add("hidden");
        } else if (this.dragging) {
          this.cancelDrag();
        } else if (this.overview) {
          this.toggleOverview();
        } else if (this.element.classList.contains("deck--full")) {
          this.setScreen(false);
        } else if (!document.fullscreenElement) {
          this.exit();
        }
        break;
      }
    }
  },
};
